module.exports = __webpack_public_path__ + "static/media/lmc.bd3176f3.png";